import get from 'hs-lodash/get';
const getFormGuid = state => get(state, 'formDefinition.definition.guid', '');
export default getFormGuid;